export enum UserLoginResult {
    Locked = -5,
    Invalid = 0,
    Success = 1,
    ChangePassword = 2,
    AlreadyLoggedIn = 3,
    WhiteListIP = 4
}
